import { createAction } from '@ngrx/store';
import { flightReshopServiceFeatureKey } from './flight-reshop-service.state';
import { SliceBySliceReshopResponse } from '../../../dtos/response/reshop-response/slice-by-slice/slice-by-slice-reshop-response';

export const initializeFlightReshopServiceState = createAction(`[${flightReshopServiceFeatureKey}] Initialize`);

export const loadSliceBySliceReshopResults = createAction(`[${flightReshopServiceFeatureKey}] Load slice by slice reshop results`);
export const loadSliceBySliceReshopResultsComplete = createAction(
  `[${flightReshopServiceFeatureKey}] Load slice by slice reshop results complete`,
  (response: SliceBySliceReshopResponse | null, error: { error?: string; errorStatus?: number } | string | null = null) => ({
    response,
    error,
  })
);

export const setSessionId = createAction(`[${flightReshopServiceFeatureKey}] Set session ID`, (sessionId: string | null) => ({
  sessionId,
}));
export const setSolutionSetId = createAction(`[${flightReshopServiceFeatureKey}] Set solution set ID`, (solutionSetId: string | null) => ({
  solutionSetId,
}));

export const resetFlightReshopServiceState = createAction(`[${flightReshopServiceFeatureKey}] Reset flight reshop service state`);
